var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"surgery-status-container"}},[_c('StatusSelect',{attrs:{"statusTime":_vm.surgery?.updated_at,"status":_vm.surgery.status},on:{"change-status":_vm.updateSurgeryStatus}}),_c('LogsModal',{attrs:{"logId":_vm.surgery?.id,"logType":"surgery-information"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }